"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const honest_react_1 = require("@digitools/honest-react");
const react_router_dom_1 = require("react-router-dom");
const useAuth_1 = __importDefault(require("../../../shared/src/hooks/useAuth"));
const applicationPermissions_1 = require("../constants/applicationPermissions");
const landingPageLinks_1 = require("../constants/landingPageLinks");
const LandingPageLink_1 = __importDefault(require("./LandingPageLink/LandingPageLink"));
const getLandingPageLinks = (landingPageLinks) => landingPageLinks.map((landingPageLink, index) => ((0, jsx_runtime_1.jsx)(LandingPageLink_1.default, { "data-testid": landingPageLink.title, linkCount: landingPageLinks.length, isFirstTile: index === 0, href: landingPageLink.href, title: landingPageLink.title, icon: landingPageLink.icon, children: landingPageLink.text }, landingPageLink.title)));
const derriveLandingPageLinks = (applicationPermissions, hasCustomerAccess) => {
    const landingPageLinks = [];
    if (applicationPermissions_1.customerAdminApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.customerAdminLink);
    }
    if (applicationPermissions_1.userAdminApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.userAdminLink);
    }
    if (applicationPermissions_1.docAdminApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.docAdminLink);
    }
    if (applicationPermissions_1.supportApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.supportLink);
    }
    if (hasCustomerAccess) {
        landingPageLinks.push(landingPageLinks_1.customerPortalLink);
    }
    if (applicationPermissions_1.dentalPortalApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.dentalProviderPortalLink);
    }
    if (applicationPermissions_1.userReportApplicationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.userReportsLink);
    }
    if (applicationPermissions_1.notificationPermissions.some((role) => applicationPermissions.indexOf(role) !== -1)) {
        landingPageLinks.push(landingPageLinks_1.notificationsLink);
    }
    return landingPageLinks;
};
const LandingPage = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const { user } = (0, useAuth_1.default)();
    const landingPageLinks = derriveLandingPageLinks(user.applicationPermissions, user.accessAllCustomers || (user.customers && user.customers.length > 0));
    if (landingPageLinks && landingPageLinks.length === 0) {
        history.push('/public/unauthorized');
    }
    return (0, jsx_runtime_1.jsx)(honest_react_1.Row, { children: getLandingPageLinks(landingPageLinks) });
};
exports.default = LandingPage;
